<template>
  <div class="table-box" ref="tableBox">
    <el-table :data="standardDangerData" :span-method="dangerSpanMethod" border height="360"
              header-cell-class-name="risk-table-header" cell-class-name="cell-class">
      <el-table-column label="#" prop="index" width="50" align="center">
      </el-table-column>
      <el-table-column prop="insecurityText" label="典型事件" width="300" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div class="insecurity" @click="onInsecurityClick(scope.row)">
            {{ scope.row.insecurityText }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="dangerDesc" label="危险源描述" width="400">
        <template slot-scope="scope">
          <div class="danger-desc-box">
            <div class="danger-desc" @click="onDangerDescClick(scope.row)">
              {{ scope.row.dangerDesc }}
            </div>
            <div class="detail-link">
              <el-tooltip class="item" effect="dark" content="点击查看危险源详情" placement="right-start">
                <el-link type="primary" :underline="false" target="_blank"
                         :href="$util.buildSmsActivityDetailUrl(scope.row.activityId)">
                  <i class="el-icon-view"></i>
                </el-link>
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ecDept" label="屏障分类" align="center">
      </el-table-column>
      <el-table-column prop="riskLevel" label="风险等级" align="center">
        <template slot-scope="scope">
          <div :class="$util.getRiskLevelColor(scope.row.riskLevelColor)">
            {{ scope.row.riskLevel }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="barrierDesc" label="屏障" width="400" :show-overflow-tooltip="true">
      </el-table-column>
<!--      <el-table-column prop="barrierStatus" label="屏障状态" align="center">
        <template slot-scope="scope">
          <div :class="$util.getRiskLevelColor(scope.row.barrierStatusColor)">
            {{ scope.row.barrierStatus }}
          </div>
        </template>
      </el-table-column>-->
    </el-table>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";

export default {
  props: {
    coreRisk: String,
  },
  data() {
    return {
      tableData: [],
    }
  },
  mounted() {
    this.buildData();
  },
  methods: {
    buildData() {
      getRequest("/risk/danger/list", {
        coreRisk: this.coreRisk
      }, this.$refs.tableBox).then(res => {
        this.tableData = res.data
      })
    },
    onDangerDescClick(row) {
      this.$emit('update:danger', {id: row.dangerId, num: row.dangerNum});
    },
    onInsecurityClick(row) {
      this.$emit('update:insecurity', {code: row.insecurity, name: row.insecurityText});
    },
    dangerSpanMethod({row, column, rowIndex, columnIndex}) {
      //危险源列合并
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        if (row.dangerMerge) {
          if (row.dangerMerge > 1) {
            return [row.dangerMerge, 1]
          } else {
            return [1, 1]
          }
        } else {
          return [0, 0];
        }
      }
      //风险等级列合并
      else if (columnIndex === 3 || columnIndex === 4) {
        if (row.assessMerge) {
          if (row.assessMerge > 1) {
            return [row.assessMerge, 1]
          } else {
            return [1, 1]
          }
        } else {
          return [0, 0];
        }
      }
    },
  },
  watch: {
    coreRisk() {
      this.buildData();
    },
  },
  computed: {
    standardDangerData() {
      let index = 1;
      let merge = 1;
      this.tableData.forEach(function (item) {
        if (item.dangerMerge)
          merge = item.dangerMerge

        item.index = index;
        merge--;

        if (merge === 0)
          index++;
      })
      return this.tableData;
    }
  },
}
</script>

<style scoped lang="less">
.table-box {
  .insecurity {
    color: #4b99fe;

    &:hover {
      cursor: pointer;
    }
  }

  .danger-desc-box {
    display: flex;
    justify-content: space-between;
    //危险源描述
    .danger-desc {
      color: #4b99fe;

      &:hover {
        cursor: pointer;
      }
    }

    .detail-link {
      display: flex;
      align-items: end;
      word-break: keep-all;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/risk/CoreRiskDanger.vue